"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var ViewWrapper = function (_a) {
    var children = _a.children, label = _a.label, classNames = _a.classNames;
    return (react_1["default"].createElement(Grid_1["default"], { container: true, spacing: 3, alignItems: "center", className: classNames === null || classNames === void 0 ? void 0 : classNames.container },
        react_1["default"].createElement(Grid_1["default"], { item: true, xs: 12, sm: 4, className: classNames === null || classNames === void 0 ? void 0 : classNames.labelContainer },
            react_1["default"].createElement(Typography_1["default"], { className: classNames === null || classNames === void 0 ? void 0 : classNames.label }, label)),
        react_1["default"].createElement(Grid_1["default"], { item: true, xs: 12, sm: 8, className: classNames === null || classNames === void 0 ? void 0 : classNames.valueContainer }, children)));
};
exports["default"] = ViewWrapper;
